import * as vp from 'vopay';

import { FunctionComponent } from 'react';
import SubAccountsList from './SubAccounts/SubAccountsList';
import type { AccountsHandlers } from './types';

type DetailsProps = {
  subAccountList: vp.AccountBalance[];
  details: vp.AccountDetailsMap;
  handlers: AccountsHandlers;
};

type FC = FunctionComponent<DetailsProps>;

const SubAccounts: FC = (props: DetailsProps) => {
  const { handlers, details, subAccountList } = props;
  return <SubAccountsList subAccountsList={subAccountList} details={details} exportCSV={handlers.exportCSV} />;
};

export default SubAccounts;
